import { Component, EventEmitter, OnInit, Output } from '@angular/core';

@Component({
  selector: 'app-assessment-guideness',
  templateUrl: './assessment-guideness.component.html',
  styleUrl: './assessment-guideness.component.scss'
})
export class AssessmentGuidenessComponent implements OnInit {
	@Output() nextButton = new EventEmitter<boolean>();

	ngOnInit() {
		setTimeout(() => {
			this.nextButton.emit(true);
		}, 1000);
	}
}
